export function whichPageAreWeOn(paths: string[]) {
    // Which page are we on? Possible paths:
    return {
        onHomePage: paths.length === 2 && paths[1] === '',
        onTeamPage: paths.length === 2 && paths[1] === 'team',
        onContentSearchPage: paths.length === 2 && paths[1] === 'content-search',
        onAskArwenPage: paths.length === 2 && paths[1] === 'ask-arwen',
        onReportPage: paths.length === 2 && paths[1] === 'report',
        onContactUsPage: paths.length === 2 && paths[1] === 'support',
        onAboutPage: paths.length === 2 && paths[1] === 'about',
        onSpamPage: paths.length === 3 && paths[1] === 'admin' && paths[2] === 'spam-model',
        onAccountPage: paths.length > 2 && paths[1] === 'account',
        // Admin
        onTeamAdminPage: paths.length === 3 && paths[1] === 'admin' && paths[2] === 'team',
        onUserAdminPage: paths.length === 3 && paths[1] === 'admin' && paths[2] === 'user',
        onCommenterAdminPage: paths.length === 3 && paths[2] === 'commenter',
        onPromptTestingPage:
            paths.length >= 3 && paths[1] === 'admin' && paths[2] === 'prompt-testing',
        onServiceHealthPage:
            paths.length === 3 && paths[1] === 'admin' && paths[2] === 'service-health',
        onCookiesPage: paths.length >= 3 && paths[1] === 'admin' && paths[2] === 'cookie',
        onReferrerAdminPage: paths.length >= 3 && paths[1] === 'admin' && paths[2] === 'referrer',
        onPostAdminPage: paths.length >= 3 && paths[1] === 'admin' && paths[2] === 'post',
        onScreenshotAdminPage:
            paths.length >= 3 && paths[1] === 'admin' && paths[2] === 'screenshot',
        onScheduledJobsPage:
            paths.length >= 3 && paths[1] === 'admin' && paths[2] === 'scheduled-jobs',

        onClassifierLibraryAdminPage:
            paths.length === 3 && paths[1] === 'admin' && paths[2] === 'classifiers',
        onOrganisationsAdminPage:
            paths.length === 3 && paths[1] === 'admin' && paths[2] === 'organisations',
        onWireframesPage: paths.length >= 2 && paths[1] === 'wireframes'
    }
}
